import React from 'react';
import styles from './SocialButtonsList.scss';
import { IconButton } from '../IconButton/IconButton';
import classNames from 'classnames';
import { facebookIcon } from '@justgiving/icons';
import Svg from '@justgiving/svg';
import { useSocialShare } from '../../hooks';

interface FacebookShareRoundProps {
  className?: string;
}

export const FacebookShareRound: React.FunctionComponent<FacebookShareRoundProps> = ({
  className,
}) => {
  const { shareOnFacebook } = useSocialShare();

  return (
    <IconButton
      className={`${styles.roundButton} ${className}`}
      onClick={shareOnFacebook}
    >
      <div className={classNames(styles.iconWrapper, styles.facebook)}>
        <Svg markup={facebookIcon} className={styles.icon} />
      </div>
      Facebook
    </IconButton>
  );
};
